import { registerRootComponent } from 'expo'; // for the Expo development environment

import App from './App';

// registerRootComponent calls AppRegistry.registerComponent('main', () => App);
registerRootComponent(App);
